module.exports = __webpack_public_path__ + "img/element-simple_container.836ec51.svg";